// Path relatif terhadap apiBaseUrl (`.../v1/`), sama seperti modul cuti.
export const ENDPOINT = '/web-apps/dashboard-school/student-leave-request';

// Kunci query. Task 5 (badge menu) memakai PENDING_COUNT_KEY lewat
// useStudentLeavePendingCount, jadi jangan diganti tanpa menyesuaikan itu.
export const REQUESTS_KEY = 'student-leave-requests';
export const PENDING_COUNT_KEY = 'student-leave-pending-count';

export const PAGE_LIMIT = 10;
export const PENDING_REFETCH_MS = 60000;
export const TOAST_DURATION_MS = 4000;
export const EMPTY = '—';

// Chakra terpasang tidak punya style prop fontVariantNumeric; pakai lewat sx.
export const TABULAR_NUMS = { fontVariantNumeric: 'tabular-nums' };

export const CATEGORY_LABEL = {
  sick: 'Sakit',
  leave: 'Izin',
  holiday: 'Liburan',
};

export const STATUS_LABEL = {
  pending: 'Menunggu',
  approved: 'Disetujui',
  rejected: 'Ditolak',
};

export const STATUS_COLOR = {
  pending: 'orange',
  approved: 'green',
  rejected: 'red',
};

export const DECIDER_ROLE_LABEL = {
  operator: 'Operator',
  teacher: 'Wali kelas',
};

export const STATUS_FILTERS = [
  { value: 'pending', label: 'Menunggu' },
  { value: 'approved', label: 'Disetujui' },
  { value: 'rejected', label: 'Ditolak' },
  { value: 'all', label: 'Semua' },
];

export const DEFAULT_FILTERS = {
  status: 'pending',
  search: '',
  idRombel: '',
  start: '',
  end: '',
  page: 1,
  limit: PAGE_LIMIT,
};

// Status yang berarti keputusan tidak bisa diulang: modal ditutup supaya
// operator melihat daftar yang sudah diperbarui.
export const FINAL_DECISION_ERROR_STATUSES = [404, 409];
